import React from 'react';
import { gbInstitucionalTheme } from '@grupoboticario/flora';
import { Box } from '@grupoboticario/flora-react-box';
import { resetCssStyles } from './reset';

if (typeof window !== 'undefined' && 'ResizeObserver' in window === false) {
  window.ResizeObserver = require('@juggle/resize-observer').ResizeObserver;
}
/**
 * @component
 * @name FloraProvider
 * @example
 * import { gbInstitucionalTheme } from '@grupoboticario/flora'
 * import { FloraProvider } from '@grupoboticario/flora-react'
 * <>
 * <FloraProvider theme={gbInstitucional}>
 *   <MyComponent />
 *   </FloraProvider>
 * </>
 * @description
 * Use to provide a theme to the application
 * @tutorial https://flora.gb.tech/docs/components/core/flora-provider
 */


export var FloraProvider = _ref => {
  var {
    resetCSS = true,
    theme = gbInstitucionalTheme,
    children,
    css
  } = _ref;
  resetCSS && resetCssStyles();
  React.useEffect(() => {
    document.documentElement.classList.add(theme);
  }, [theme]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    "data-flora": "provider",
    className: theme,
    css: css
  }, children));
};
//# sourceMappingURL=FloraProvider.js.map